import React, {Component} from 'react';
import {Dropdown} from 'semantic-ui-react';
import {connect} from 'react-redux';
import {Actions} from '../../../../common/actions';
import {startsWith} from '../../../../common/util/dropdown';

class VehicleSelector extends Component {
  componentDidMount() {
    this.props.fetchVehiclesList();
  }

  parseVehicle(vehicles = []) {
    return vehicles.map((item) => ({'text': item[0], 'value': item[0]}));
  }

  render() {
    const {value, name, vehiclesList, loading, changeValue} = this.props;
  
    return (
      <Dropdown
        selection
        fluid
        name={name}
        search={startsWith}
        value={value}
        loading={loading}
        disabled={loading}
        options={this.parseVehicle(vehiclesList)}
        onChange={changeValue}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.pncVehicles.loading,
    'vehiclesList': state.pncVehicles.list,
  };
};

const {fetchVehiclesList} = Actions;

export default connect(mapStateToProps, {fetchVehiclesList})(VehicleSelector);
